import { useStringFlagValue } from '@openfeature/react-sdk';

import {
  CAPABILITY_SIGNALLING_DEFAULT,
  CAPABILITY_SIGNALLING_FLAG_KEY,
  parseCapabilitySignallingVariant,
  type CapabilitySignallingVariant,
} from './capability-signalling-variant';

export {
  CAPABILITY_SIGNALLING_DEFAULT,
  CAPABILITY_SIGNALLING_FLAG_KEY,
  CAPABILITY_SIGNALLING_VARIANTS,
  parseCapabilitySignallingVariant,
  type CapabilitySignallingVariant,
} from './capability-signalling-variant';

/**
 * Assigned arm of the in-session capability-signalling experiment.
 *
 * Multivariate string flag on OpenFeature/Flagsmith — not PostHog. Bucketing is
 * on user id so a clinician does not see the composer change between visits.
 *
 * Lives in this standalone `.ts` module (not the `index.ts` barrel) so it does
 * not add a `react-refresh/only-export-components` warning. Import via
 * `@/features/flags`, which re-exports it.
 */
export const useCapabilitySignallingVariant = (): CapabilitySignallingVariant =>
  parseCapabilitySignallingVariant(
    useStringFlagValue(CAPABILITY_SIGNALLING_FLAG_KEY, CAPABILITY_SIGNALLING_DEFAULT)
  );
